













































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import { classPrintWorld } from '@/common/js/PrintWorld'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import { routers } from '@/router/router'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import UpdateOderStatu from './update-abroadorder-status.vue'
    import UpdatebackoverseasreturnorderStatu from '@/store/entities/back-updatestatus'
    import BaleStockOrder from './bale-abroadorder.vue'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    import moment from 'moment'
    Vue.use(Preview);


    class PageOverseasRequest extends PageRequest {
        //WarehouseOrderStatus?: number ;
        //WarehouseOrderPackageStatus?: number;
        orderStatus?: number;
        packageStatus?: number;
        SearchInfo: string;
        BeginTime?: Date;
        storeId?: number;
        EndTime?: Date;
        PlatformType: number;
        constructor() {
            super();
            this.orderStatus = null;
            this.packageStatus = null;
            this.PlatformType = null;
        }
    }


    @Component({
        name: "backoverseasreturnorder",
        components: { BaleStockOrder, UpdateOderStatu }
    })
    export default class Orders extends AbpBase {
        pagerequest: PageOverseasRequest = new PageOverseasRequest();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        orderStatus = Enums.getEnum(Enums.WarehouseOrderStatus, true);
        packageStatus = Enums.getEnum(Enums.WarehouseOrderPackageStatus, true);
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        storeaddressList: Array<storeaddressInfo> = [];
        isLoadPrintList: boolean = false;
        logisticsList: string[] = [];
        orderNumberList: string[] = [];
        baleStockOrderModal: boolean = false;
        automaticJump: boolean = true;
        updateOderStatuShow = false;
        get list() {
            return this.$store.state.backoverseasreturnorder.list;
        };
        get loading() {
            return this.$store.state.backoverseasreturnorder.loading;
        }
        pageChange(page: number) {
            this.$store.commit('backoverseasreturnorder/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backoverseasreturnorder/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.backoverseasreturnorder.currentPage = 1;
            this.getpage();
        }
        async getpage() {
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

            await this.$store.dispatch({
                type: 'backoverseasreturnorder/getAll',
                data: this.pagerequest
            });

            var _this: any = this;
            _this.$previewRefresh();
        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            this.storeaddressList.push(a);

        }
        async Newpacked(data: any) {

            //var selectionData: any = this.$refs.selection;
            //var selection = selectionData.getSelection();
            //if (!selection || selection.length == 0) {
            //    this.$Message.error("选中项不能为空！");
            //    return;
            //}
            var ids = [];
            var abnormalOrderList: any[] = [];
            //for (var i = 0; i < selection.length; i++) {


            //}
            //if (selection[i].productOrderStatus != 2) {
            //    this.orderNumberList.push(selection[i].orderNumber);

            if (data.productOrderStatus !== null && data.productOrderStatus !== undefined) {
                var statuName = Enums.ProductOrderStatus.filter(function (item) { return item.value == data.productOrderStatus })[0].name;
                if (statuName != "待发货") {
                    this.orderNumberList.push(data.orderNumber);
                }
            }
            if (data.abnormalUserId) {
                abnormalOrderList.push({ orderNumber: data.orderNumber, abnormalUserId: data.abnormalUserId });
            }
            this.ShowPacked(data.id, abnormalOrderList);

            this.$store.state.backabroadorder.BaseSkuNums = data.orderProductInfoList.length;
        
        }



        async ShowPacked(id: number, abnormalOrderList: any[]) {
            this.$store.state.backabroadorder.id = id;

            this.$store.state.backabroadorder.abnormalOrderList = abnormalOrderList;
            this.automaticJump = false;
            this.baleStockOrderModal = true;
        }

        async cancelBale() {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            this.$Modal.confirm({
                title: "取消打包", content: "确认批量将订单取消打包？", onOk: async () => {
                    var ids = [];
                    for (var i = 0; i < selection.length; i++) {
                        ids.push(selection[i].id);
                    }
                    await this.$store.dispatch({
                        type: 'backabroadorder/cancleBale',
                        data: { ids: ids }
                    });
                    this.getpage();

                }
            });
        }

        async pendingWarehouse() {
            this.updatePackageStatus(6);
        }
        async updatePackageStatus(statu: number) {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var statuName = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == statu })[0].name;

            this.$Modal.confirm({
                title: "修改包裹状态", content: "确认批量将此订单处理为" + statuName + "？", onOk: async () => {
                    var ids = [];
                    for (var i = 0; i < selection.length; i++) {
                        ids.push(selection[i].id);
                    }
                    await this.$store.dispatch({
                        type: 'backabroadorder/updatePackageStatus',
                        data: { ids: ids, PackageStatus: statu }
                    });
                    this.getpage();

                }
            });
        }
        async arriveWarehouse() {
            this.updatePackageStatus(4);
        }

        printPdf(data) {

            if (!this.isLoadPrintList) {
                var printWorld = new classPrintWorld(); //new一个打天下对象。不提供URL参数，意为本机的打天下打印服务器（"http://127.0.0.1:8888"）。
                var json = {
                    action: "", refresh: true, defaultprn: true, error: "", val: {}
                };
                json.action = "printers";
                json.refresh = true;                      //为true，则可确保返回刚刚添加的打印机。
                json.defaultprn = true;                   //是否包含缺省打印机信息。
                json = printWorld.Direct(json);
                if (json == null) {//数据发送失败
                    alert(printWorld.GetLastError());
                } else if (json.error != undefined) {   //打天下打印服务返回的错误信息
                    alert(json.error);
                } else {    //处理包含打印机列表的json
                }


                var Options = new Array();
                for (var i in json.val) {
                    var option = document.createElement('option');
                    option.innerHTML = json.val[i].name;
                    option.value = json.val[i].name;
                    document.getElementById('SelectPrint').appendChild(option);
                }
                this.isLoadPrintList = true;
                this.$Message.success("已加载打印机，请选择指定打印机");
                return;
            }


            var pdfData = {
                pdfGuid: data.pdfGuid,
                userId: data.userId,
                orderNumber: data.orderNumber,
                url: '',
            };
            this.$store.commit('fontmainlandorder/getPdfUrl', pdfData);

            var printSelect: any = document.querySelector('#SelectPrint');
            if (!printSelect.value) {
                this.$Message.success("请选择指定打印机");
                return;
            }
            if (pdfData.url && pdfData.url.length > 0) {
                var printWorld = new classPrintWorld(); //new 一个打天下对象
                var jsons = { action: "", format: "", content: "", printer: "", cert: "", paperlength: 0, paperwidth: 0 };
                jsons.action = "printfile";
                jsons.format = "pdf_url";        //指定格式为pdf_url。
                jsons.content = pdfData.url;   //pdf文件的url路径
                jsons.paperlength = 15;
                jsons.paperwidth = 10;
                jsons.cert = "https://warehouse.ddtmx.com/cer/fileprintauth.ctf";
                jsons.printer = printSelect.value;    //打印机名称，为空或者不指定，则通过缺省打印机打印。
                printWorld.Direct(jsons);
            }
        }
        //async arriveWarehouse() {
        //    this.updatePackageStatus(4);
        //}

        async AllarriveWarehouse() {
            var statuName = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == 4 })[0].name;
            this.$Modal.confirm({
                title: "一键送仓", content: "确认批量将包裹状态处理为【" + statuName + "】？", onOk: async () => {
                    await this.$store.dispatch({
                        type: 'backabroadorder/oneClickDelivery',
                        data: {}
                    });
                    this.getpage();
                }
            });

        }
        get pageSize() {
            return this.$store.state.backoverseasreturnorder.pageSize;
        }
        get totalCount() {
            return this.$store.state.backoverseasreturnorder.totalCount;
        }
        get currentPage() {
            return this.$store.state.backoverseasreturnorder.currentPage;
        }
        async operationData(name: any, data: any) {
            if (name == "复制订单编号") {
                this.copyInfo(data.orderNumber);
            }
            else if (name == "复制快递单号") {
                var stringList: Array<string> = [];
                data.logistics.forEach(function (element) {
                    stringList.push(element.shipment);
                });
                this.copyInfo(stringList.join("/"));
            }
            else if (name == '标记为异常') {
                var updateData = new UpdatebackoverseasreturnorderStatu();
                updateData.id = data.id;
                updateData.orderStatus = -1;
                updateData.reMark = data.warehouseNote;
                updateData.orderNumber = data.orderNumber;
                this.$store.state.backabroadorder.updateOrdeData = updateData;
                this.updateOderStatuShow = true;
            } else if (name == '标记为正常') {
                var updateData = new UpdatebackoverseasreturnorderStatu();
                updateData.id = data.id;
                updateData.orderStatus = 0;
                updateData.reMark = data.warehouseNote;
                updateData.orderNumber = data.orderNumber;
                updateData.abnormalImageUploadGuid = data.abnormalImageUploadGuid,
                    this.$store.state.backabroadorder.updateOrdeData = updateData;
                this.updateOderStatuShow = true;
            }
            else if (name == '撤销订单') {
                await this.$store.dispatch({
                    type: 'backabroadorder/cancleStockOrder',
                    data: { stockOrderId: data.id }
                });
                this.getpage();
            }
        }
        copyInfo(data) {
            var _this = this;
            this.$copyText(data).then(function (e) {
                _this.$Message.success("复制成功");
            }, function (e) {
                _this.$Message.error("复制失败");
            });
        }
        columns = [
            {
                type: 'selection',
                width: 60,
                align: 'center',

            },  
            {
                title: '仓储名称',
                key: 'storeName',
                width: 150,
            }, {
                title: '订单编号',
                key: 'orderNumber',
                width: 150,
            }, {
                title: '订单状态',
                width: 100,
                key: 'orderStatus',
                render: (h: any, params: any) => {
                    var warehouseNote = params.row.warehouseNote;
                    if (warehouseNote) {
                        warehouseNote = "(" + warehouseNote + ")";
                    }
                    else {
                        warehouseNote = "";
                    }
                    return h('div', [h('p', Enums.WarehouseOrderStatus.filter(function (item) { return item.value == params.row.orderStatus })[0].name), [h('p', { style: { color: 'red' } }, warehouseNote)]]
                    )
                }
            },
            {
                title: '退件类码',
                key: 'returnNo',
                width: 170,
            },
            {
                title: '异常图片',
                key: 'abnormalImageUploadGuid',
                width: 95,
                render: (h: any, params: any) => {
                    if (params.row.abnormalImageUploadGuid) {
                        var data = { imageGuid: params.row.abnormalImageUploadGuid, url: null };
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: "yc_" + params.row.id,
                                "preview-text": params.row.orderNumber + "异常图片"
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            {
                title: '备注',
                width: 200,
                key: 'reMark',
                render: (h: any, params: any) => {
                    return h('div', [h('span', { style: { color: 'red' } }, params.row.reMark)]
                    )
                }
            }, {
                title: '包裹状态',
                width: 90,
                key: 'packageStatus',
                render: (h: any, params: any) => {
                    return h('span', Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name);
                }
            },

            {
                title: '创建时间',
                key: 'createTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
                }
            },
            {
                title: '退件订单来源',
                width: 120,
                key: 'source',
                render: (h: any, params: any) => {
                    return h('span', Enums.ReturnOrderSource.filter(function (item) { return item.value == params.row.source })[0].name);
                }
            },
            {
                title: '商品信息',
                width: 300,
                key: 'orderProductInfoList',
                render: (h: any, params: any) => {
                    var _this = this;
                    return h('ul', params.row.orderProductInfoList.map(item => {
                        var img = item.url ? '<img src="' + item.url + '" alt="' + item.productName + '" class="img"  onclick="handleChangeImg()" >' : "";
                        return h('li', {
                        }, [
                            h('img', {
                                attrs: {
                                    class: "img",
                                    src: item.url,
                                    preview: params.row.id,
                                    "preview-text": params.row.orderNumber + "-" + item.productName
                                }
                            }), item.productName, h('font', { style: { color: "red" } }, '*'), item.count]);
                    }));
                }
            },
            {
                title: '站点',
                width: 100,
                key: 'site',
                render: (h: any, params: any) => {
                    return h('span', Enums.SiteSType.filter(function (item) { return item.value == params.row.site })[0].name);
                }
            },
            {
                title: '货物类别',
                width: 90,
                key: 'cargoCategory',
                render: (h: any, params: any) => {
                    return h('span', Enums.CargoCategoryType.filter(function (item) { return item.value == params.row.cargoCategory })[0].name);
                }
            },
            {
                title: '送仓时间',
                key: 'arriveWarehouseTime',
                width: 120,
                render: (h: any, params: any) => {
                    return h('span', params.row.arriveWarehouseTime ? DateUtils.formatLongDate(new Date(params.row.arriveWarehouseTime)) : '');
                }
            },
            {
                title: '打包袋数量',
                key: 'sackNums',
                width: 80,
            },
            {
                title: '基本SKU数量',
                key: 'baseSkuNums',
                width: 80,
            },
            {
                title: '打包袋金额',
                key: 'sackTotalAmount',
                width: 80,
            },
            {
                title: 'SKU金额',
                key: 'skuTotalAmount',
                width: 80,
            }, {
                title: '操作',
                width: 100,
                fixed: 'left',
                key: 'id',
                render: (h: any, params: any) => {
                    var _this = this;
                    var menu = [];
                    var data = params.row;
                    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                    var productOrderStatusName = "";
                    if (data.productOrderStatus != null) {
                        productOrderStatusName = Enums.ProductOrderStatus.filter(function (item) { return item.value == data.productOrderStatus })[0].name;
                    }
                    var orderStatus = Enums.WarehouseOrderStatus.filter(function (item) { return item.value == data.orderStatus })[0].name;
                    var _this = this;
                    var menu = [];
                    //if (params.row.pdfGuid && params.row.pdfGuid.length > 1) {
                    //    menu.push("查看Pdf");
                    //}
                    if (params.row.orderStatus == 0 && params.row.packageStatus != 5) {
                        menu.push("标记为异常");
                    }
                    if (params.row.orderStatus == -1 && params.row.packageStatus != 5) {
                        menu.push("标记为正常");
                    }
                    if (params.row.orderStatus == -1) {
                        menu.push("撤销订单");
                    }
                    menu.push("复制订单编号");
                    if (params.row.logistics && params.row.logistics.length > 0) {
                        menu.push("复制快递单号");
                    }
                    return h('div', [
                        h('Dropdown', {
                            props: {
                                transfer: true,
                                trigger: 'click',
                            },
                            on: {
                                'on-click': (name) => {
                                    _this.operationData(name, params.row);
                                }
                            }

                        }, [
                            h('Button',
                                {
                                    domProps: {
                                        innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                                    },
                                    props: {
                                        type: 'primary',
                                    }

                                }),

                            h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                                return h('DropdownItem', { props: { name: item } }, item)
                            })
                            )],
                        ),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '68px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    var _this = this;
                                    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                                    if (packageStatus != "已收货") {
                                        this.$Modal.confirm({
                                            title: "打印PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否打印此订单的面单？", onOk: async () => {
                                                _this.printPdf(data);
                                            }
                                        });
                                    }
                                    else {
                                        _this.printPdf(data);
                                    }
                                }
                            }
                        }, "打印PDF"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '68px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    if (params.row.pdfGuid && params.row.pdfGuid.length > 1) {
                                        this.$store.commit('backoverseasreturnorder/getPdf', {
                                            pdfGuid: data.pdfGuid,
                                            orderNumber: data.orderNumber
                                        });
                                    }
                                }
                            }

                        }, "查看PDF"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '68px',
                                height: '30px',
                                display: (packageStatus == "未收货" || packageStatus == "已收货" && orderStatus == "正常") && productOrderStatusName != "已取消" ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {

                                    this.Newpacked(data);
                                }
                            }

                        }, "打包")
                   
                    ]);

                }
            }]
        async created() {
            //var abnormal = abp.getQueryVariable("abnormal");
            //if (abnormal && abnormal == 'true') {
            //    this.pagerequest.orderStatus = -1;
            //}
            this.getpage();
            this.getData();
        }
    }
